import { COLORS } from '@constants/colors';
import { IStyles } from '@interfaces/styles';

import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = (): IStyles => {
  const { appTheme } = useMytaverse();

  return {
    root: {
      p: 0,
      width: '100%',
    },

    permissionsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      '& img': {
        width: '100%',
        height: 'auto',
        maxWidth: 325,
      },
      mt: 4,
    },

    subRoot: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      '& > div': {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      },
    },

    button: {
      width: '100%',
      maxWidth: 320,
      height: 180,
      mt: 2,
      backgroundColor: COLORS.GREY,
      color: COLORS.LIGHT_GREY,
      borderRadius: 4,

      '&:hover': {
        backgroundColor: appTheme.mainColor,
      },
    },

    videoButton: {
      width: '100%',
      padding: 0,
      mt: 2,
    },
  };
};
